import store from "./store";

export const changeStore = async (reducerType: string, data: any): Promise<void> => {
  await store.dispatch({
    type: reducerType,
    payload: data,
  });
};

export const currentStore = () => {
  return store?.getState();
};
